import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    setMobileMenuOpen(false);
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4">
        <nav className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <div className="h-[30px] w-auto flex items-center justify-center flex-shrink-0"><img src="/logo.png" alt="Ariv" className="h-[30px] w-auto object-contain" /></div>
          </Link>

          {/* Desktop Navigation */}
          <ul className="hidden md:flex items-center gap-8">
            <li>
              <button
                onClick={() => scrollToSection('features')}
                className="text-gray-700 hover:text-[#1F3A68] font-medium transition-colors"
              >
                Features
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('how-it-works')}
                className="text-gray-700 hover:text-[#1F3A68] font-medium transition-colors"
              >
                How It Works
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('integrations')}
                className="text-gray-700 hover:text-[#1F3A68] font-medium transition-colors"
              >
                Integrations
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('pricing')}
                className="text-gray-700 hover:text-[#1F3A68] font-medium transition-colors"
              >
                Pricing
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('calculator')}
                className="text-gray-700 hover:text-[#1F3A68] font-medium transition-colors"
              >
                Calculator
              </button>
            </li>
          </ul>

          {/* Desktop Buttons */}
          <div className="hidden md:flex items-center gap-4">
            <Button variant="outline" onClick={() => navigate('/login')}>
              Log In
            </Button>
            <Button onClick={() => navigate('/signup')}>
              Get Started
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <ul className="flex flex-col gap-4">
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="block w-full text-left text-gray-700 hover:text-[#1F3A68] font-medium py-2"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('how-it-works')}
                  className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium py-2"
                >
                  How It Works
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('integrations')}
                  className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium py-2"
                >
                  Integrations
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('pricing')}
                  className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium py-2"
                >
                  Pricing
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('calculator')}
                  className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium py-2"
                >
                  Calculator
                </button>
              </li>
              <li className="flex flex-col gap-2 pt-2">
                <Button variant="outline" className="w-full" onClick={() => navigate('/admin')}>
                  Log In
                </Button>
                <Button className="w-full" onClick={() => scrollToSection('cta')}>
                  Start Free Trial
                </Button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
